<template>
  <v-row id="project-tasks-and-estimates-tab">
    <v-col cols="12">
      <AddEstimateDialog
        v-if="dialog"
        :is-opened="dialog"
        :task-type-items="taskTypeList"
        :role-items="estimationRoles"
        @close="closeDialog"
        @save="onDialogSave"
      />

      <div style="width: 100%;">
        <EstimatesTable
          class="w-100"
          :items="estimations"
          :task-types="taskTypeList"
          :roles="estimationRoles"
          :allowed="allowed"
          :project="project"
          @add="openDialog"
          @afterImport="loadData"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import AddEstimateDialog from '@/components/projects/AddEstimateDialog.vue';
import EstimatesTable from '@/components/projects/EstimatesTable.vue';

export default {
  components: {
    EstimatesTable,
    AddEstimateDialog,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
    projectId: {
      type: [String, Number],
      required: true,
    },
    allowed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      label: 'Project Task Types',
      searchValue: '',
      selectedTaskTypes: [],
      dialog: false,
    };
  },
  computed: {
    ...mapGetters('projects/main', [
      'projectEstimations',
      'projectEstimationRoles',
      'projectTaskTypes',
    ]),
    ...mapGetters('shared/taskTypes', [
      'allTaskTypes',
      'projectsTaskTypes',
    ]),

    currentProjectTaskTypes() {
      return this.projectsTaskTypes[this.projectId] || [];
    },
    estimationRoles() {
      return this.projectEstimationRoles;
    },
    estimations() {
      return this.projectEstimations;
    },
    taskTypeList() {
      return [...new Set(this.currentProjectTaskTypes.map((t) => t.title))];
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions('projects/main', [
      'getProjectEstimations',
      'getProjectEstimationRoles',
    ]),
    ...mapActions('shared/taskTypes', [
      'getAllTaskTypes',
      'getProjectsTaskTypes',
      'addTaskType',
      'deleteTaskType',
    ]),

    async loadData() {
      await this.getAllTaskTypes();
      await this.updateTaskTypes();
      await this.getProjectEstimations({ projectId: this.projectId });
      await this.getProjectEstimationRoles({ projectId: this.projectId });

      this.selectedTaskTypes = [...this.currentProjectTaskTypes];
    },

    async updateTaskTypes() {
      return Promise.all([
        this.getAllTaskTypes(),
        this.getProjectsTaskTypes({ projectIds: [this.projectId] }),
      ]);
    },

    clearSearchValue() {
      this.searchValue = '';
    },

    async handleTaskTypesChange(taskTypes) {
      const isAddition = this.currentProjectTaskTypes.length < taskTypes.length;
      const toggledElem = this.getChangeElement(taskTypes, isAddition);

      if (typeof toggledElem === 'string') {
        if (!toggledElem.trim()) {
          taskTypes.pop();

          return;
        }
      }

      if (isAddition) {
        await this.addTaskType({
          taskTypeTitle: typeof toggledElem === 'string' ? toggledElem : toggledElem.title,
          projectId: this.projectId,
        });
        this.clearSearchValue();
      } else {
        await this.deleteTaskType({
          projectId: this.projectId,
          taskTypeId: toggledElem.id,
        });
      }

      await this.updateTaskTypes();
    },

    getChangeElement(selected, isAddition) {
      if (isAddition) {
        return selected.find((elem) => !this.currentProjectTaskTypes.includes(elem));
      }

      return this.currentProjectTaskTypes.find((elem) => !selected.includes(elem));
    },

    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    onDialogSave() {
      this.loadData();
    },
  },
};
</script>

<style lang="less">
.project-tasks-tab .v-chip {
  border-radius: 4px;
  height: unset;

  .v-chip__content {
    white-space: normal;
    padding: 4px 0;
  }
}
</style>
